var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.photoViewer.status)?_c('el-image-viewer',{attrs:{"z-index":"9999","url-list":[_vm.photoViewer.path],"on-close":() => _vm.photoViewer.status = false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }